var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "c-grid-view-item",
      class: {
        "c-grid-view-item--folder": _vm.item.type === "folder",
        "is-selected": _vm.isSelected,
        "is-upload-target": _vm.dragMode === "upload",
      },
      attrs: { title: _vm.getTitle(_vm.item) },
      on: {
        dragstart: function ($event) {
          return _vm.$emit("dragstart", $event)
        },
        drop: _vm.handleDrop,
        dragover: _vm.handleDragEnter,
        dragleave: _vm.handleDragLeave,
      },
    },
    [
      _vm.isTooltipVisible
        ? _c("div", { staticClass: "tooltip" }, [
            _vm._v("\n    " + _vm._s(_vm.tooltip) + "\n  "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "c-grid-view-item__preview",
          class: {
            active: _vm.isSelected,
            "is-actions-open": _vm.isActionsMenuOpen,
          },
          attrs: {
            role: "button",
            tabindex: "0",
            "aria-pressed": _vm.isSelected ? "true" : "false",
            "aria-label": _vm.selectionAriaLabel,
          },
          on: {
            click: function ($event) {
              return _vm.$emit("click", _vm.item)
            },
            dblclick: _vm.handleDoubleClick,
            keydown: [
              function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                $event.preventDefault()
                return _vm.$emit("click", _vm.item)
              },
              function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "space", 32, $event.key, [
                    " ",
                    "Spacebar",
                  ])
                )
                  return null
                $event.preventDefault()
                return _vm.$emit("click", _vm.item)
              },
            ],
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "c-grid-view-item__preview--item",
              class: { active: _vm.isSelected || Boolean(_vm.dragMode) },
            },
            [
              _vm.parsedTitle
                ? _c("PSDPreviewBadge", {
                    attrs: {
                      left: "5",
                      top: "5",
                      variant: "success",
                      title: _vm.parsedTitle,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isLimited
                ? _c(
                    "b-badge",
                    {
                      staticClass: "limited-label",
                      attrs: { pill: "", variant: "warning" },
                    },
                    [_vm._v("\n        Limited\n      ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.cornerActions, function (action) {
                return _c(
                  "span",
                  {
                    key: action.name,
                    staticClass:
                      "c-grid-view-item__action c-grid-view-item__action--corner",
                    class: { "is-active": _vm.isActionActive(action) },
                    attrs: { title: _vm.actionTitle(action) },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.$emit("action", {
                          name: action.name,
                          item: _vm.item,
                        })
                      },
                    },
                  },
                  [_c("b-icon", { attrs: { icon: _vm.actionIcon(action) } })],
                  1
                )
              }),
              _vm._v(" "),
              !_vm.cornerActions.length && _vm.item.is_favorite
                ? _c("b-icon", {
                    staticClass: "favorite-icon",
                    attrs: { icon: "bookmark-fill" },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.hasProcessingErrors
                ? _c(
                    "b-badge",
                    {
                      staticClass: "error-badge",
                      attrs: {
                        pill: "",
                        variant: "danger",
                        title:
                          "Upload failed or stuck. Please delete and try again.",
                      },
                    },
                    [
                      _c("i", { staticClass: "fas fa-exclamation-triangle" }),
                      _vm._v(" Error\n      "),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("ItemView", {
                attrs: { item: _vm.item },
                on: {
                  "image-missing": function ($event) {
                    _vm.isImageMissing = true
                  },
                },
              }),
              _vm._v(" "),
              _vm.showCounter
                ? _c(
                    "div",
                    {
                      staticClass: "select-same-image-container",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                        },
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "mines",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.$emit("count-change", -1)
                            },
                          },
                        },
                        [_vm._v("-")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "counter" }, [
                        _vm._v(
                          "\n          " + _vm._s(_vm.count) + "\n        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "plus",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.$emit("count-change", 1)
                            },
                          },
                        },
                        [_vm._v("+")]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.item.is_processing && !_vm.hasProcessingErrors
                ? _c(
                    "div",
                    {
                      staticClass: "c-grid-view-item__preview--progress w-100",
                    },
                    [
                      _c("b-progress", {
                        staticClass: "a-progressing__bar",
                        attrs: {
                          value: _vm.item.percent,
                          variant: "success",
                          striped: "",
                          animated: "",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showCheckbox && _vm.item.type !== "folder"
                ? _c("input", {
                    staticClass: "form-check-input c-grid-view-item__checkbox",
                    attrs: { type: "checkbox" },
                    domProps: { checked: _vm.isSelected },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.$emit("click", _vm.item)
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.showDownloadIcon && _vm.item.type !== "folder"
                ? _c(
                    "button",
                    {
                      staticClass: "c-grid-view-item__download",
                      attrs: { type: "button", title: "Download" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.$emit("download", _vm.item)
                        },
                      },
                    },
                    [
                      _c("b-icon", {
                        attrs: { icon: "download", "font-scale": "1.1" },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "c-grid-view-item__preview--overlay" },
                [
                  _vm.showCopyToFileBrowser
                    ? _c(
                        "span",
                        {
                          staticClass: "copy-to-browser",
                          attrs: { title: "Copy to File Browser..." },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.$emit("copy-to-file-browser", _vm.item)
                            },
                          },
                        },
                        [_c("CopyIcon", { attrs: { width: 16, height: 16 } })],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showMagnifier && !_vm.isImageMissing
                    ? _c(
                        "span",
                        {
                          staticClass: "magnifier",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.$emit("open-preview", _vm.item)
                            },
                          },
                        },
                        [
                          _c("SearchIcon", {
                            attrs: { width: 16, height: 16 },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showDragHandle
                    ? _c(
                        "span",
                        {
                          staticClass: "drag-handle",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                            },
                            mousedown: function ($event) {
                              $event.stopPropagation()
                            },
                          },
                        },
                        [
                          _c("GripVerticalIcon", {
                            attrs: { width: 16, height: 16 },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.overlayActions, function (action) {
                    return _c(
                      "span",
                      {
                        key: action.name,
                        staticClass: "c-grid-view-item__action",
                        class: `c-grid-view-item__action--${
                          action.variant || "default"
                        }`,
                        attrs: { title: _vm.actionTitle(action) },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.$emit("action", {
                              name: action.name,
                              item: _vm.item,
                            })
                          },
                        },
                      },
                      [
                        _c("b-icon", {
                          attrs: { icon: _vm.actionIcon(action) },
                        }),
                      ],
                      1
                    )
                  }),
                  _vm._v(" "),
                  _vm.isAvailableOverlay && _vm.item.name !== "..."
                    ? _c("ItemActionsDropdown", {
                        attrs: { item: _vm.item },
                        on: {
                          open: function ($event) {
                            _vm.isActionsMenuOpen = true
                          },
                          close: function ($event) {
                            _vm.isActionsMenuOpen = false
                          },
                        },
                      })
                    : _vm._e(),
                ],
                2
              ),
              _vm._v(" "),
              _vm.item.type === "folder"
                ? _c("div", { staticClass: "c-grid-view-item__folder_name" }, [
                    _c("span", { attrs: { title: _vm.folderNameTitle } }, [
                      _vm._v(_vm._s(_vm.item.name)),
                    ]),
                    _vm._v(" "),
                    _vm.showEditButton
                      ? _c(
                          "button",
                          {
                            staticClass: "folder-edit-btn",
                            attrs: { title: "Rename folder" },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.$emit("edit", _vm.item)
                              },
                            },
                          },
                          [_c("i", { staticClass: "fa fa-edit" })]
                        )
                      : _vm._e(),
                  ])
                : _vm._e(),
            ],
            2
          ),
        ]
      ),
      _vm._v(" "),
      _vm.item.type !== "folder"
        ? _c(
            "div",
            {
              staticClass: "c-grid-view-item__name",
              class:
                _vm.item.asset_type === "salsify"
                  ? "c-grid-view-item__name--external"
                  : "c-grid-view-item__name--regular",
              attrs: { title: _vm.fileDisplayName },
            },
            [_vm._v("\n    " + _vm._s(_vm.fileDisplayName) + "\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.item?.asset_type === "salsify" && _vm.item?.is_product
        ? _c("div", { staticClass: "c-grid-view-item__external-id" }, [
            _c("span", [_vm._v(_vm._s(_vm.item?.salsify_id))]),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }